import * as React from 'react';
import { NavLink, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Container, Menu } from 'semantic-ui-react';

import { Contexto } from 'src/contexto';
import IngresoNuevaMatriculaConURLState from './IngresoNuevaMatricula/IngresoNuevaMatriculaConURLState';
import MisMatriculas from './MisMatriculas';
import { puedePoseerMatriculas } from './puedePoseerMatriculas';

type Props = RouteComponentProps<{}>;

const MatriculasPrincipal: React.FunctionComponent<Props> = props => {
    const rutaBase = props.match.url;

    return (
        <Contexto.Consumer>
            {({ usuarioActual }) => (
                <Container>
                    {puedePoseerMatriculas(usuarioActual) && (
                        <Menu pointing secondary>
                            <Menu.Item as={NavLink} exact to={rutaBase} content='Mis matrículas' />
                            <Menu.Item
                                as={NavLink}
                                exact
                                to={`${rutaBase}/nueva`}
                                content='Ingresar nueva matrícula'
                            />
                        </Menu>
                    )}

                    <Switch>
                        {!puedePoseerMatriculas(usuarioActual) && (
                            // Si no es un asesor solo puede ver el formulario, así que
                            // por ahora se redirecciona directamente a él
                            <Redirect exact from={rutaBase} to={`${rutaBase}/nueva`} />
                        )}

                        <Route
                            exact
                            path={`${rutaBase}/nueva`}
                            component={IngresoNuevaMatriculaConURLState}
                        />
                        <Route path={rutaBase} component={MisMatriculas} />
                    </Switch>
                </Container>
            )}
        </Contexto.Consumer>
    );
};

export default MatriculasPrincipal;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/MatriculasPrincipal.tsx